
// Both helpers now RETURN what callHandler returns — the Promise the Flutter
// handler resolves — instead of throwing the value away, and `undefined` when
// there is no Flutter shell to talk to.
//
// Nothing that called these before reads the return value, so this changes no
// existing behaviour. It exists for the 'share' event (see utils/shareLink.js),
// which has to know whether the app actually took the share: if it did not, the
// web side must fall back to its own share/copy path rather than doing nothing.

export function sendEvent(event, ...data) {
    console.log(event,data,"event")
    // eslint-disable-next-line no-undef
    if (isFlutterInAppWebViewReady) {
        const args = {
            event: event,
            data: data
        };
        return window.flutter_inappwebview.callHandler('Qushi', args);
    }
    return undefined;
}

export function event(event, data) {
    console.log(event,data,"event")
    // eslint-disable-next-line no-undef
    if (isFlutterInAppWebViewReady) {
        const args = {
            event: event,
            data: data
        };
        return window.flutter_inappwebview.callHandler('Qushi', args);
    }
    return undefined;
}
